import React, { useState } from 'react'
import isProd from '../../utils/constants/isProd'
import ModalInfo from '../productinfo/ModalInfo'

const Image = ({ articleBrandParts }) => {
    const [isModalActive, setIsModalActive] = useState(false)

    return (
        <>
            <ModalInfo
                articleBrandParts={articleBrandParts}
                title={articleBrandParts.title}
                brand={articleBrandParts.brand_title}
                article={articleBrandParts.original_article}
                isModalActive={isModalActive}
                setIsModalActive={setIsModalActive}
                activeTab={1}
            />

            <div className="result-table__info-image">
                <div
                    className="result-table__info-image-wrapper"
                    onClick={() => setIsModalActive(true)}
                >
                    {isProd && articleBrandParts.image ? (
                        <img src={articleBrandParts.image} alt="" />
                    ) : (
                        <svg
                            width="28"
                            height="25"
                            viewBox="0 0 28 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M24.6665 3.33332H20.4398L17.9998 0.666656H9.99984L7.55984 3.33332H3.33317C1.8665 3.33332 0.666504 4.53332 0.666504 5.99999V22C0.666504 23.4667 1.8665 24.6667 3.33317 24.6667H24.6665C26.1332 24.6667 27.3332 23.4667 27.3332 22V5.99999C27.3332 4.53332 26.1332 3.33332 24.6665 3.33332ZM24.6665 22H3.33317V5.99999H8.73317L11.1732 3.33332H16.8265L19.2665 5.99999H24.6665V22ZM13.9998 7.33332C10.3198 7.33332 7.33317 10.32 7.33317 14C7.33317 17.68 10.3198 20.6667 13.9998 20.6667C17.6798 20.6667 20.6665 17.68 20.6665 14C20.6665 10.32 17.6798 7.33332 13.9998 7.33332ZM13.9998 18C11.7998 18 9.99984 16.2 9.99984 14C9.99984 11.8 11.7998 9.99999 13.9998 9.99999C16.1998 9.99999 17.9998 11.8 17.9998 14C17.9998 16.2 16.1998 18 13.9998 18Z"
                                fill="#DADADA"
                            />
                        </svg>
                    )}
                </div>
            </div>
        </>
    )
}

export default Image
